import { RoomState } from './types';

export const roomInitialState: RoomState = {
  roomId: null,
  roomName: null,
  roomUuid: null,
  bamRoomId: null,
  roomCountry: null,
};
